export const getFeedbackIcon = (type) => {
    const feedbackColors = {
        error: 'cancel',
        success: 'check_circle',
        warning: 'error',
    };
    return feedbackColors[type];
};
export const validateFeedbackTranslation = (name, value) => {
    switch (name) {
        case 'password': {
            return 'Informe uma senha válida.';
        }
        case 'confirmPassword': {
            return 'As senhas não correspondem.';
        }
        case 'email': {
            if (!Email(value || "").validate)
                return 'Informe um e-mail válido.';
            return 'E-mail já cadastrado.';
        }
        case 'cpf': {
            if (!CPF(value || "").validate)
                return 'Informe um CPF válido.';
            return 'CPF já cadastrado.';
        }
        case 'cnpj': {
            return 'Informe um CNPJ válido.';
        }
        default: {
            return 'Informe um campo válido.';
        }
    }
};
export const getHelpTextProps = ({ feedback, helpText, }) => {
    if (!feedback?.type && !helpText)
        return null;
    if (feedback?.type) {
        return {
            color: `--semantic-${feedback.type}-base`,
            message: feedback.message,
        };
    }
    return {
        message: helpText,
    };
};
//# sourceMappingURL=helpers.js.map